import React from 'react';
import {t} from '@lingui/core/macro';

export default function EventContentState({loading, error, retry}) {
    return <section role={error ? 'alert' : 'status'} style={{maxWidth:680,marginInline:'auto',padding:'48px 24px',minHeight:'35vh',color:'inherit'}}>
        <p>{loading ? t`Chargement…` : error ? t`Impossible de charger le contenu.` : t`Événement introuvable`}</p>
        {error && retry && <button type='button' onClick={retry} style={{font:'inherit',padding:'12px 20px',minHeight:48,borderRadius:12,cursor:'pointer'}}>{t`Réessayer`}</button>}
    </section>;
}
